import { mergeStyles, mergeStyleSets } from '@fluentui/react';
import { buttonStylesStealth, buttonStylesTextWithIconRight, FontSizes, FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export const signInButtonStyles = (theme: IH2OTheme) =>
  mergeStyleSets(buttonStylesStealth, buttonStylesTextWithIconRight, {
    root: {
      border: 'none',
      fontSize: FontSizes.small,
      color: theme.semanticColors?.textPrimary,
    },
    rootHovered: {
      color: theme.semanticColors?.textPrimary,
    },
    label: {
      fontWeight: FontWeights.fw400,
    },
    icon: {
      color: theme.semanticColors?.textPrimary,
      fontWeight: FontWeights.fw800,
      fontSize: '0.7em',
    },
  });

export const manageWorkspacesWrapperStyles = (theme: IH2OTheme) =>
  mergeStyles({
    backgroundColor: theme.palette?.white,
    borderTop: `1px solid ${theme.palette?.gray300}`,
    insetBlockEnd: 0,
    position: `sticky`,
    a: {
      display: 'block',
      padding: '8px 16px',
      textDecoration: 'none',
      color: theme.semanticColors?.textPrimary,
      ':hover': { backgroundColor: theme.palette?.gray200 },
    },
  });

export const membersDropdownWrapperStyles = (theme: IH2OTheme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 332,
    height: 32,
    '.ms-TooltipHost': {
      fontSize: FontSizes.medium,
      lineHeight: 0,
      margin: '0 8px',
      cursor: 'default',
      color: theme.palette?.gray500,
      i: { display: 'block' },
    },
  },
});

export const navLoadingStyles = {
  root: {
    '.h2o-AppBarNavigation-menuIcon': {
      animation: 'nav-menu-icon-slide-in 0.3s ease-out forwards',
    },
    '.h2o-AppBarNavigation-root > .h2o-NavigationSection-root': {
      animation: 'nav-section-slide-in 0.3s ease-out forwards',
    },
  },
};
